<div class="flex w-full text-[14px] leading-[24px]">

    <!-- Farbbalken links, Muster app-task-row-v2-component. Ersetzt den Punkt im Titel. -->
    <div class="w-[5px] shrink-0" [style.background-color]="barColor"></div>

    <div class="flex-1 min-w-0 px-2 py-2 flex flex-col">

        <!-- Band 1: Titel, rechts die Verwaltungsgesten. Muster: dashboard-announcements —
             dieselben zwei Knoepfe, dieselbe Stelle, damit Banner und Glocke sich gleich bedienen. -->
        <div class="flex flex-row items-start gap-2">
            <div class="min-w-0 flex-1" [ngClass]="[titleWeightClass, dimClass]">
                <!-- Korrekturmeldung (Client-Dok §8.2): dieselbe Aussage, die die zugehoerige Mail
                     im Betreff („Korrektur:") schon traegt. -->
                @if (notification?.correctsAnnouncementId) {
                    <span data-testid="correction-badge"
                          class="mr-1 px-1 rounded bg-[#EBEEEF] text-[#848488] text-[12px] font-medium">
                        {{ 'notificationComponent.correction' | translate }}
                    </span>
                }
                {{notification?.title}}
            </div>
            <div class="flex flex-row gap-1 shrink-0">
                <!-- Client-Dok §3: gelesen ohne zu oeffnen. Auch bei sticky erlaubt, deshalb haengt
                     dieser Knopf nur am Lesezustand. -->
                <nx-default-button
                    *ngIf="!notification?.readAt"
                    [icon]="'icon-check'"
                    [tooltip]="'notificationComponent.markAsRead' | translate"
                    (click)="onMarkReadClicked(notification); $event.stopPropagation()">
                </nx-default-button>
                <!-- #736 §12: Wegraeumen ohne Wiederherstellen. Bewusst ohne Rueckfrage.
                     Client-Dok §3/§8.6: bei sticky lehnt der Server das Loeschen ohnehin ab — der
                     Riegel ist das Rueckfallnetz, nicht der Bedienweg, deshalb hier gar nicht erst
                     anbieten. -->
                <nx-default-button
                    *ngIf="!notification?.sticky"
                    [icon]="'icon-trash'"
                    [tooltip]="'notificationComponent.delete' | translate"
                    (click)="onDeleteClicked(notification); $event.stopPropagation()">
                </nx-default-button>
            </div>
        </div>

        <!-- Band 2: Inhalt. Ankuendigungen ungekuerzt — die Liste scrollt endlos, es gibt kein
             festes Sichtfeld mehr, aus dem eine lange Ankuendigung andere Zeilen schoebe. -->
        @if (bodyHtml) {
          <div data-testid="body-rich" class="font-light text-[#848488] nx-view-tipTap"
               [ngClass]="dimClass" [innerHTML]="bodyHtml"></div>
        } @else if (notification?.body) {
          <div class="font-light text-[#848488]" [ngClass]="dimClass">{{ notification?.body }}</div>
        }

        <!-- Band 3: Zeit links, die typabhaengige Aktion rechts. Ohne Ziel bleibt rechts nichts —
             das Markieren macht der Haken oben. -->
        <div class="flex flex-row justify-between items-center gap-2 mt-1">
            <div class="font-light text-[#848488]" [ngClass]="dimClass">
                <app-relative-time [timestamp]="notification?.createdAt"></app-relative-time>
            </div>
            <nx-default-button
                *ngIf="hasAction"
                [style]="'dark'"
                (click)="onDetailsClicked(notification); $event.stopPropagation()"
                [label]="detailsLabel">
            </nx-default-button>
        </div>

    </div>
</div>
